export const PUBLIC_MARKETING_HEADER_COPY_BN = {
  "product": "পণ্য",
  "solutions": "সমাধান",
  "tools": "টুলস",
  "resources": "সম্পদ",
  "platformExports": "প্ল্যাটফর্ম রপ্তানি",
  "metadataTools": "মেটাডেটা টুল",
  "display": "প্রদর্শন",
  "displayPreferences": "প্রদর্শন সেটিংস",
  "zoom": "জুম",
  "theme": "থিম",
  "switchTheme": "থিম পরিবর্তন করুন",
  "studio": "স্টুডিও খুলুন",
  "menu": "মেনু",
  "closeMenu": "মেনু বন্ধ করুন",
  "navigation": "প্রধান মেনু",
  "navigationDescription": "Stocktag পণ্য, সরঞ্জাম, সংস্থান এবং অ্যাকাউন্ট সেটিংস অন্বেষণ করুন৷",
  "account": "হিসাব",
  "legal": "আইনি",
  "social": "সামাজিক প্রোফাইল",
  "about": "সম্পর্কে",
  "editorial": "সম্পাদকীয় নীতি",
  "contact": "যোগাযোগ",
  "privacy": "গোপনীয়তা বিজ্ঞপ্তি",
  "terms": "পরিষেবার শর্তাবলী"
};

export const PUBLIC_MARKETING_FOOTER_COPY_BN = {
  "ctaEyebrow": "এখানে আপনার পরবর্তী ব্যাচ শুরু করুন",
  "ctaTitle": "মার্কেটপ্লেস-প্রস্তুত মেটাডেটা দিয়ে আপনার ছবি প্রকাশ করুন।",
  "ctaBody": "একটি ওয়ার্কস্পেস থেকে সবকিছু তৈরি করুন, পর্যালোচনা করুন এবং রপ্তানি করুন।",
  "studio": "Metadata Studio খুলুন",
  "seePricing": "মূল্য দেখুন",
  "product": "পণ্য",
  "tools": "টুলস",
  "resources": "সম্পদ",
  "account": "হিসাব",
  "company": "কোম্পানি",
  "legal": "আইনি",
  "footerNavigation": "ফুটার নেভিগেশন",
  "platformExports": "প্ল্যাটফর্ম রপ্তানি",
  "metadataTools": "মেটাডেটা টুল",
  "tagline": "স্টক নির্মাতাদের জন্য একটি সম্পূর্ণ মেটাডেটা কর্মপ্রবাহ।",
  "about": "সম্পর্কে",
  "editorial": "সম্পাদকীয় নীতি",
  "contact": "যোগাযোগ",
  "privacy": "গোপনীয়তা বিজ্ঞপ্তি",
  "terms": "পরিষেবার শর্তাবলী",
  "social": "Stocktag সামাজিক প্রোফাইল"
};

export const PUBLIC_MARKETING_FOOTER_FLOW_BN = {
  "label": "প্রকাশনা কর্মপ্রবাহ",
  "input": "উত্স ছবি",
  "studio": "Metadata Studio",
  "review": "মেটাডেটা পর্যালোচনা করা হয়েছে",
  "export": "ফাইল আপলোড করার জন্য প্রস্তুত"
};

export const PUBLIC_HOME_UI_COPY_BN = {
  "productSceneAlt": "প্রজন্মের সেটিংস, আপলোড ওয়ার্কস্পেস এবং মেটাডেটা পর্যালোচনা নিয়ন্ত্রণ সহ Stocktag Metadata Studio",
  "aiBridgeAlt": "AI ইমেজ স্টুডিওতে তৈরি টেকসই শহরের চিত্র, Metadata Studio এ আপলোড করার আগে ডাউনলোড করার জন্য প্রস্তুত",
  "heroInputLabel": "উৎস ফাইল",
  "heroAnalyze": "ভিজ্যুয়াল বিশ্লেষণ সম্পূর্ণ",
  "heroTitleReady": "শিরোনাম এবং কীওয়ার্ড প্রস্তুত",
  "heroReadyFor": "Adobe Stock এর জন্য প্রস্তুত",
  "heroFileName": "alpine-hiker.jpg",
  "heroSampleTitle": "সূর্যোদয়ের সময় একটি শান্ত আলপাইন হ্রদ উপেক্ষা করছে হাইকার",
  "heroKeywords": [
    "হাইকার",
    "আলপাইন হ্রদ",
    "সূর্যোদয়"
  ],
  "platformEyebrow": "মার্কেটপ্লেস প্রস্তুত",
  "workflowEyebrow": "এক অবিচ্ছিন্ন কর্মপ্রবাহ",
  "exportEyebrow": "আপলোড করার আগে প্রস্তুত",
  "trialEyebrow": "অতিথি ডেমো",
  "trialLimit": "একটি ট্রায়াল প্রতি সাইট এবং IP ঠিকানা প্রতি দিন উপলব্ধ. Metadata Studio এ আপনার নির্বাচিত ফাইলের সাথে চালিয়ে যান।",
  "videoDuration": "1 মিনিট 31 সেকেন্ড",
  "capabilityEyebrow": "প্রতিটি বৈশিষ্ট্য",
  "toolsEyebrow": "কাজের জন্য সরঞ্জাম",
  "exploreAllTools": "সমস্ত Stocktag টুল এক্সপ্লোর করুন",
  "marketEyebrow": "বাজার বুদ্ধি",
  "sampleSignal": "নমুনা সংকেত",
  "exploreMarket": "Market Intelligence এক্সপ্লোর করুন",
  "modulesEyebrow": "স্টুডিও সরঞ্জাম",
  "exportsEyebrow": "মার্কেটপ্লেস-প্রস্তুত ফাইল",
  "generatorEyebrow": "এআই ইমেজ স্টুডিও",
  "openGenerator": "এআই ইমেজ স্টুডিও খুলুন",
  "generateStep": "তৈরি করুন",
  "tagStep": "ডাউনলোড করুন",
  "exportStep": "আপলোড করুন",
  "outputsEyebrow": "একটি বাস্তব আউটপুট উদাহরণ",
  "copy": "কপি",
  "copied": "কপি করা হয়েছে",
  "previewOnly": "এটি একটি নির্বাচনযোগ্য পূর্বরূপ। রপ্তানি Metadata Studio এ সঞ্চালিত হয়।",
  "whyEyebrow": "স্টক অবদানকারীদের জন্য",
  "compareEyebrow": "কর্মপ্রবাহের তুলনা",
  "beforeAfterEyebrow": "ম্যানুয়াল কাজ থেকে একটি নিয়ন্ত্রিত কর্মপ্রবাহ",
  "trustEyebrow": "রপ্তানির আগে নিয়ন্ত্রণ",
  "testimonialsEyebrow": "ব্যবহারের উদাহরণ",
  "pricingEyebrow": "সঠিক পরিকল্পনা নির্বাচন করুন",
  "faqEyebrow": "প্রায়শই জিজ্ঞাসিত প্রশ্ন",
  "routesEyebrow": "অন্বেষণ করতে থাকুন",
  "finalEyebrow": "এখনই চেষ্টা করে দেখুন",
  "beforeLabel": "Stocktag এর আগে",
  "afterLabel": "Metadata Studio সহ",
  "stocktagLabel": "Stocktag",
  "genericLabel": "সাধারণ-উদ্দেশ্য AI",
  "selectedPlatform": "নির্বাচিত প্ল্যাটফর্ম",
  "formatPreview": "বিন্যাস পূর্বরূপ",
  "workflowImages": [
    "Metadata Studio-এ ফাইল আমদানি করা হচ্ছে",
    "মেটাডেটা জেনারেশন সেটিংস",
    "ব্যাচ মেটাডেটা পর্যালোচনা",
    "মার্কেটপ্লেস রপ্তানি নিয়ন্ত্রণ"
  ]
};

export const HOME_SKIP_TO_MAIN_LABEL_BN = "প্রধান বিষয়বস্তু এড়িয়ে যান";

export const HOME_MAIN_CONTENT_LABEL_BN = "হোম কন্টেন্ট";


export default PUBLIC_HOME_UI_COPY_BN;
